import { useCallback, useState } from 'react';

const hasVisited = (key: string): boolean => {
  try {
    return window.localStorage.getItem(key) !== null;
  } catch {
    return false;
  }
};

const rememberVisit = (key: string) => {
  try {
    window.localStorage.setItem(key, '1');
  } catch {
    return;
  }
};

export const useNewUntilVisited = (key: string | null) => {
  const [visitedKey, setVisitedKey] = useState<string | null>(null);

  const markVisited = useCallback(() => {
    if (key === null) return;
    rememberVisit(key);
    setVisitedKey(key);
  }, [key]);

  return { isNew: key !== null && visitedKey !== key && !hasVisited(key), markVisited };
};
